import React from 'react';
const EdmSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-worktable" });
EdmSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-worktable sirius-icon-worktable-enhance" });
export default EdmSvg;
